/**
 * Mock Agent Sessions and Messages
 *
 * Initial state is empty - sessions are created by user actions.
 */

import type { CpAgentSession, CpAgentMessage, AgentConfig } from '../../../types/curriculum_planning';

// Default agent configuration
export const defaultAgentConfig: AgentConfig = {
  model: {
    provider: 'openai',
    name: 'gpt-4o',
  },
  generation: {
    temperature: 0.3,
    maxTokens: 4096,
  },
  extraction: {
    confidenceThreshold: 0.8,
    maxClarifications: 10,
    autoMapKnownSubjects: true,
  },
  ui: {
    showThinking: true,
    showDetailedProgress: true,
  },
};

// Initial empty state - sessions are created dynamically
export const mockCpAgentSessions: CpAgentSession[] = [];

// Initial empty state - messages are created dynamically
export const mockCpAgentMessages: CpAgentMessage[] = [];
